module.exports = angular.module('cartographer.common.api.survey', [])

_ = require 'underscore'
defaultPermissions = require "../../plugin/survey/permissions.generated"

module.exports.factory 'crtSurvey', $DI (
  crtLog
  crtConfig
  crtPromise
  crtHttp
) ->
  # Map of survey plugins, each providing type-specific survey functionality
  # (create a blank survey, create a survey form, create a map overlay, etc).
  plugins = {}

  # Register a new plugin
  # string plugin -> void
  registerPlugin = (plugin) ->
    crtLog.debug("Registering survey plugin: #{plugin.id}")
    plugins[plugin.id.toLowerCase()] = plugin
    return

  optFindPlugin = (type) ->
    plugins[type.toLowerCase()]

  findPlugin = (type) ->
    plugins[type.toLowerCase()] ? throw new Error("crtSurvey.findPlugin: no such plugin: #{type}")

  all = () ->
    _.values(plugins)

  # string [string] -> promiseOf(survey)
  blank = (module, workspace, template = undefined) ->
    unless module then throw new Error("crtSurvey.blank: no module specified")
    crtHttp.get("#{crtConfig.api.rootUrl}/survey/v1/#{module}/blank", {
      workspace,
      template,
      format: "legacy"
    })

  searchSummaries = (type, options = {}) ->
    crtLog.debug('crtSurvey.searchSummaries', type, options)
    crtHttp.get("#{crtConfig.api.rootUrl}/survey/v1/#{type}/summary", _.extend(
      {}
      options
      { format: "legacy" }
    ))

  searchSurveys = (type, options = {}) ->
    crtLog.debug('crtSurvey.searchSurveys', type, options)
    crtHttp.get("#{crtConfig.api.rootUrl}/survey/v1/#{type}", _.extend(
      {}
      options
      { format: "legacy" }
    ))

  read = (type, surveyId, handlers = undefined) ->
    crtHttp.get("#{crtConfig.api.rootUrl}/survey/v1/#{type}/#{surveyId}", { format: "legacy" }, handlers)

  readNoModule = (surveyId, handlers = undefined) ->
    crtHttp.get("#{crtConfig.api.rootUrl}/survey/v1/no-module/#{surveyId}", { format: "legacy" }, handlers)

  save = (survey) ->
    if survey.id?
      crtHttp.put(crtHttp.url("#{crtConfig.api.rootUrl}/survey/v1/#{survey.type}/#{survey.id}", { format: "legacy" }), survey)
    else
      crtHttp.post(crtHttp.url("#{crtConfig.api.rootUrl}/survey/v1/#{survey.type}", { format: "legacy" }), survey)

  updateStatus = (type, surveyId, status) ->
    crtHttp.put(crtHttp.url("#{crtConfig.api.rootUrl}/survey/v1/#{type}/#{surveyId}/status", { format: "legacy" }), { status })

  del = (survey) ->
    crtHttp.delete("#{crtConfig.api.rootUrl}/survey/v1/#{survey.type}/#{survey.id}", survey)

  refreshMetadata = () ->
    crtHttp.get("#{crtConfig.api.rootUrl}/survey/v1/refresh-metadata")

  downloadUrl = (type, options = {}) ->
    crtHttp.url("#{crtConfig.api.rootUrl}/survey/v1/#{type}", _.extend(
      {}
      options
      { type, authorization: crtHttp.accessToken() }
    ))

  validate = (survey) ->
    findPlugin(survey.type).validate(survey)

  shortTypeName = (survey) ->
    optFindPlugin(survey.type).shortName() ? survey.type

  longTypeName = (survey) ->
    optFindPlugin(survey.type).longName() ? survey.type

  # TODO: This should return survey-specific text rather than just the plugin type name:
  shortSurveyName = (survey) ->
    optFindPlugin(survey.type)?.shortName() ? survey.type

  # TODO: This should return survey-specific text rather than just the plugin type name:
  longSurveyName = (survey) ->
    optFindPlugin(survey.type)?.longName() ? survey.type

  formDirective = (type) ->
    findPlugin(type).formDirective()

  # string -> arrayOf(crtSurvey)
  forWorkspace = (workspace) ->
    _.chain(workspace.surveys)
     .map(optFindPlugin)
     .filter((plugin) -> plugin?)
     .sortBy((plugin) -> plugin.shortName())
     .value()

  lookupPermissionModel = (id) ->
    defaultPermissions[id]?.permissionModel ? throw new Error("No permission model found for survey: #{id}")

  lookupCollaborationModel = (id) ->
    defaultPermissions[id]?.collaborationModel ? throw new Error("No collaboration model found for survey: #{id}")

  return {
    plugins
    registerPlugin
    optFindPlugin
    findPlugin
    all
    blank
    searchSummaries
    searchSurveys
    read
    readNoModule
    save
    updateStatus
    delete: del
    refreshMetadata
    downloadUrl
    validate
    shortTypeName
    longTypeName
    shortSurveyName
    longSurveyName
    formDirective
    forWorkspace
    lookupPermissionModel
    lookupCollaborationModel
  }
